import { render } from "./eventStatus.vue?vue&type=template&id=fa211cbe&scoped=true"
import script from "./eventStatus.vue?vue&type=script&lang=js"
export * from "./eventStatus.vue?vue&type=script&lang=js"

import "./eventStatus.vue?vue&type=style&index=0&id=fa211cbe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa211cbe"]])

export default __exports__